
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const HathinalaBiodiversity=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Hathinala Biodiversity Park</h1>
           <p className="sub-heading">A lush haven in Sonbhadra teeming with vibrant wildlife and breathtaking greenery</p>
         </div>
         <div className="description">
         Hathinala Biodiversity Park in Sonbhadra is a paradise for nature lovers, showcasing diverse flora, dense vegetation, and thriving wildlife. Home to Chinkaras, hyenas, wild boars, and more, this untouched sanctuary offers a serene escape into the heart of nature. Best visited between June and October, it promises an unforgettable experience for anyone seeking a connection with the wild.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Biodiversity Park/park1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
          
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Biodiversity Park/park22.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Biodiversity Park/park3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Biodiversity Park/park4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Biodiversity Park/park5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Biodiversity Park/park6.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
          
         </div>
   
         <BookSection />
       </div>
     );
};